module.exports = __webpack_public_path__ + "static/media/murilo-batista.846cdd90.jpg";